import {AfterViewInit, Component, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {DataFormatService} from "../../../services/data-format.service";
import {MatSort} from "@angular/material/sort";

export interface FundInvestment {
  name: string | null,
  fund_id: string | null
  fund_type: string | null,
  repeat: boolean,
  amount: number,
  investment_class: string | null,
  admitted_date: string | null,
  exit_date: string | null
}
@Component({
  selector: 'contacts-fund-investors-table',
  templateUrl: './contacts-fund-investors-table.component.html',
  styleUrls: ['./contacts-fund-investors-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})


export class ContactsFundInvestorsTableComponent  implements OnInit, AfterViewInit{
  @Input() fundInvestments:FundInvestment[]
  public fundDataSource: MatTableDataSource<FundInvestment>
  @ViewChild(MatSort) matSort: MatSort

  public fundInvestmentsColumns:string[] = ['name', 'fund_type', 'repeat', 'investment_amount', 'investment_class', 'admitted_date', 'exit_date']

  constructor(public dataFormat: DataFormatService) {
  }
  ngOnInit(){
    this.fundDataSource = new MatTableDataSource(this.fundInvestments)
  }

  ngAfterViewInit() {
    this.fundDataSource.sort = this.matSort
  }
}
